module.exports = __webpack_public_path__ + "static/media/mmg-letters.ad125982.png";